import React from 'react';
import PropTypes from 'prop-types';
import ComputedPriceField from 'components/field/ComputedPriceField';
import CustomerNameField from 'components/field/CustomerNameField';
import DateField from 'components/field/DateFields/DateField';
import DateUTCField from 'components/field/DateFields/DateUTCField';
import ProductField from 'components/field/ProductField';
import ResourceList from 'components/list/Container/ResourceList';
import Table from 'components/table/Table';
import TextField from 'components/field/TextField';
import { fetchReservations } from 'store/actions/reservations/fetchReservations';

const ReservationsList = (props) => {
    const {
        actionType,
        location,
        resource,
        updateQuery,
    } = props;

    return (
        <ResourceList
            action={ fetchReservations }
            actionType={ actionType }
            location={ location }
            resource={ resource }
            updateQuery={ updateQuery }
        >
            <Table>
                <DateUTCField
                    column={ {
                        sortable: true,
                        width: '10%',
                    } }
                    label='resources.reservations.fields.created_at'
                    source='created_at'
                />

                <TextField
                    column={ {
                        sortable: false,
                        width: '10%',
                    } }
                    label='resources.reservations.fields.internal_order_id'
                    source='internal_order_id'
                />

                <CustomerNameField
                    column={ {
                        sortable: false,
                        width: '15%',
                    } }
                    label='resources.reservations.fields.customer'
                    source='reservation_data'
                />

                <ProductField
                    column={ {
                        sortable: false,
                    } }
                    label='resources.reservations.fields.product'
                    source='product_id'
                />

                <DateField
                    column={ {
                        sortable: false,
                        width: '12%',
                    } }
                    label='resources.reservations.fields.destination_arrival_date'
                    source='reservation_data.destination_arrival_date'
                />

                <DateField
                    column={ {
                        sortable: false,
                        width: '12%',
                    } }
                    label='resources.reservations.fields.destination_departure_date'
                    source='reservation_data.destination_departure_date'
                />

                <ComputedPriceField
                    column={ {
                        sortable: false,
                    } }
                    label='fields.price'
                    source='price'
                />
            </Table>
        </ResourceList>
    );
};

ReservationsList.propTypes = {
    actionType: PropTypes.string.isRequired,
    location: PropTypes.object,
    resource: PropTypes.string.isRequired,
    updateQuery: PropTypes.func.isRequired,
};

export default ReservationsList;



// WEBPACK FOOTER //
// ./src/pages/reservations/list/ReservationsList.js